module.exports = __webpack_public_path__ + "static/img/112.eaed564.png";